import React from 'react';
import cn from 'classnames';

import Icon from '../Icon';

import live from 'assets/svg/live.svg';
import './sportFilterHeading.scss';

interface Props {
    title: string;
    logo: React.ReactNode;
    isActive: boolean;
    count?: number;
    onClick?: () => void;
    isLive?: boolean;
}

const SportFilterHeading: React.FC<Props> = ({
    isActive,
    onClick,
    title,
    logo,
    isLive,
}) => {
    return (
        <div
            styleName={cn('container', { 'is-active': isActive })}
            onClick={onClick}
        >
            {logo}
            <div styleName="ellipsis">{title}</div>
            {isLive && <Icon glyph={live} styleName="live" />}
        </div>
    );
};

export default React.memo(SportFilterHeading);
